'use client';

import type { Icon } from '@personly/libs-types';
import { Requirement } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';

import { useEmails } from '@/providers/emails';

interface Props {
  icon?: Icon;
}

const EmailRequirement = ({ icon }: Props) => {
  const { email } = useEmails();
  const { validate, requirement } = useValidators();

  return (
    email.length > 0 &&
    !validate('EMAIL', email) && (
      <Requirement icon={icon}>{requirement('EMAIL')}</Requirement>
    )
  );
};

export default EmailRequirement;
